Vendd.Scripts.load(function () {

    window.ConsentsManager = new ConsentsManager();

    function ConsentsManager() {
        var self = this;

        this.cookie = 'ConsentChecked';
        this.cookieChecked;
        this.cookiesStatus = {};

        this.cookiesWidgetWrapper = $('.x-cookie-acceptance');

        this.cookiesModalWrapper = $('.cookies-modal-container');

        this.cookieTypeCodes = [
            "FunctionalityCookies",
            "StatisticsCookies",
            "MarketingCookies"
        ];
        this.endpoints = {
            "insertConsents": "api/Consents/InsertConsents",
            "getCookiesConsentsModel": "api/Consents/GetCookiesConsentsModel",
            "insertAllCookies": "api/Consents/InsertAllCookies",
            "updateAllUserConsents": "api/Consents/UpdateAllUserConsents",
            "getCookiesWidgetModel": "api/Consents/GetCookiesWidgetModel"
        };


        //------------------------------------------------------------------------------
        this.showCookiesWidget = function () {
            if (LhApp.Context.CookiesDisplay === "Modal") {
                self.initCookiesModal();
            } else if (LhApp.Context.CookiesDisplay === "Layer" && $('.manage-cookies-container').length <= 0) {
                this.cookiesWidgetWrapper.addClass('visible');
            }
        };

        //------------------------------------------------------------------------------
        this.hideCookiesWidget = function () {
            this.cookiesWidgetWrapper.removeClass('visible');
        };

        //------------------------------------------------------------------------------
        this.createOrUpdateCookie = function () {
            var date = new Date();
            date.setTime(date.getTime() + (60 * 60 * 1000));
            Cookies.set(self.cookie, self.cookiesStatus, { expires: date, samesite: 'Lax' });

            /*Expose Cookie Consents to Data Layer*/
            var consentsCookie = Cookies.getJSON('ConsentChecked');
            if (consentsCookie) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ 'functionalityCookiesEnabled': consentsCookie.functionalityCookies, 'marketingCookiesEnabled': consentsCookie.marketingCookies, 'statisticCookiesEnabled': consentsCookie.statisticCookies });
            }
        };

        //------------------------------------------------------------------------------
        this.getCookieStatus = function () {
            self.cookiesStatus = !self.cookieChecked ? {
                userHasSetCookies: false,
                functionalityCookies: LhApp.Context.CookiesDefaultActive,
                statisticCookies: LhApp.Context.CookiesDefaultActive,
                marketingCookies: LhApp.Context.CookiesDefaultActive
            } : Cookies.getJSON(self.cookie);
        };

        //------------------------------------------------------------------------------
        this.onGetCookieModelSuccess = function (res) {

            self.cookiesStatus.userHasSetCookies = res.UserHasSetCookies;
            if (self.cookiesStatus.userHasSetCookies) {
                self.cookiesStatus.functionalityCookies = res.ApprovedFunctionalityCookies;
                self.cookiesStatus.marketingCookies = res.ApprovedMarketingCookies;
                self.cookiesStatus.statisticCookies = res.ApprovedStatisticsCookies;
            }

            self.createOrUpdateCookie();
            self.activateCookies();

            if (!res.UserHasSetCookies) {
                self.showCookiesWidget();
            } else {
                self.hideCookiesWidget();
            }
        };

        //------------------------------------------------------------------------------
        this.insertConsents = function (data) {
            var type = data.type;

            function onSuccess(response) {

                if (jQuery.inArray(type, self.cookieTypeCodes) > -1) {
                    self.getCookieConsentsModel();
                }

                Vendd.MessageBus.publishAsync(Vendd.Consents, new Vendd.Consents.Messages.InsertConsents);
            }

            function onFailure(response) {
                return response;
            }

            var options = {
                method: 'POST',
                url: self.endpoints.insertConsents,
                data: data,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            Vendd.Service.call(options);
        };

        var dontLoadOnLoginSuccess;
        Vendd.MessageBus.subscribe(Vendd.User.Messages.Login, self, function (envelope) {
            dontLoadOnLoginSuccess = envelope.message.data.options && envelope.message.data.options.isLoginForm;

            if (dontLoadOnLoginSuccess)
                Cookies.remove(self.cookie, { path: '/' });
        });

        //------------------------------------------------------------------------------
        this.getCookieConsentsModel = function (afterInsertAllCookiesSuccess) {
            if (dontLoadOnLoginSuccess)
                return;

            function onSuccess(response) {
                self.onGetCookieModelSuccess(response.data);

                if (afterInsertAllCookiesSuccess || (!self.cookieChecked && !afterInsertAllCookiesSuccess && response.data.UserHasSetCookies))
                    Vendd.MessageBus.publishAsync(Vendd.Consents, new Vendd.Consents.Messages.InsertAllCookiesSuccess);
            }

            function onFailure(response) {
                return response;
            }

            var options = {
                method: 'GET',
                url: self.endpoints.getCookiesConsentsModel + "?v=" + Math.random(),
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            Vendd.Service.call(options);
        };

        //------------------------------------------------------------------------------
        this.insertAllCookies = function (data) {

            function onSuccess(response) {
                self.getCookieConsentsModel(true);
            }

            function onFailure(response) {
                return response;
            }

            var options = {
                method: 'POST',
                url: self.endpoints.insertAllCookies,
                data: data,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            Vendd.Service.call(options);
        };

        //------------------------------------------------------------------------------
        this.updateAllUserConsents = function () {

            function onSuccess(response) {
                self.getCookieConsentsModel();
            }

            function onFailure(response) {
                return response;
            }

            var options = {
                method: 'GET',
                url: self.endpoints.updateAllUserConsents,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            Vendd.Service.call(options);
        };

        //------------------------------------------------------------------------------
        this.getCookiesWidgetModel = function () {

            function onSuccess(response) {

                var initModalHtml = self.cookiesModalWrapper.html();

                response.data = $.extend(response.data, { cookiesModal: true });

                /*update model with cookie values*/
                var consentsCookie = Cookies.getJSON(self.cookie);
                if (consentsCookie) {
                    $.map(response.data.Cookies, function (e) { return e.IsActive = (e.ConsentTypeCode == "FunctionalityCookies") ? consentsCookie.functionalityCookies : (e.ConsentTypeCode == "StatisticsCookies") ? consentsCookie.statisticCookies : (e.ConsentTypeCode == "MarketingCookies") ? consentsCookie.marketingCookies : e.IsActive });
                }

                var html = Vendd.Handlebars.parse("cookiesManager", response.data);
                self.cookiesModalWrapper.html(html);
                //$.fancybox.update();

                var tabsCont = $('.tabs-container', self.cookiesModalWrapper);
                var scrollContConfig = $('.js-scrollbar', self.cookiesModalWrapper);

                if (!isTouch() && scrollContConfig) {
                    scrollContConfig.mCustomScrollbar({
                        scrollbarPosition: "outside",
                        scrollInertia: 400,
                        timeout: 1000,
                        theme: "dark-2",
                        mouseWheel: { preventDefault: false },
                    });
                }

                $('.tab-title', tabsCont).click(function () {
                    var thisTab = $(this);
                    thisTab.addClass('active').siblings().removeClass('active');

                    $('.tab-content:eq(' + thisTab.index() + ')', tabsCont).addClass('active').siblings().removeClass('active');
                });

                $('.js-save-cookies-btn', self.cookiesModalWrapper).click(function () {
                    var data = { fCookies: true, sCookies: true, mCookies: true, source: 'Cookie Consent Page' }, type;

                    $('.switch-checkbox', self.cookiesModalWrapper).each(function () {
                        type = $(this).closest('div[data-type]').data('type');

                        if (type === "FunctionalityCookies") {
                            data.fCookies = $(this).is(":checked");
                        } else if (type === "StatisticsCookies") {
                            data.sCookies = $(this).is(":checked");
                        } else if (type === "MarketingCookies") {
                            data.mCookies = $(this).is(":checked");
                        }

                    });

                    self.insertAllCookies(data);
                    $.fancybox.close();
                });

                $('.js-back-to-modal', self.cookiesModalWrapper).click(function () {
                    self.cookiesModalWrapper.html(initModalHtml);
                });
            }

            function onFailure(response) {
                return response;
            }

            var options = {
                method: 'GET',
                url: self.endpoints.getCookiesWidgetModel,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            Vendd.Service.call(options);
        }

        //------------------------------------------------------------------------------
        this.registerEvents = function () {

            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, self, function () {
                //update tagmanager consents if enabled
                var trackingModel = LhApp.Function.Tracking.getTrackingModel();
                if (trackingModel && trackingModel.EnableGoogleTagManagerConsents) {
                    LhApp.Function.Tracking.gtag('consent', 'update', {
                        'ad_storage': window.ConsentsManager.cookiesStatus.marketingCookies ? 'granted' : 'denied',
                        'analytics_storage': window.ConsentsManager.cookiesStatus.statisticCookies ? 'granted' : 'denied',
                        'functionality_storage': window.ConsentsManager.cookiesStatus.functionalityCookies ? 'granted' : 'denied'
                    });
                }
                if (dataLayer.filter(function (l) { return l['event'] && l['event'] == 'vendd_consents_ready' }) == 0) {
                    dataLayer.push({ 'event': 'vendd_consents_ready' });
                }
            });

            Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, self, function (envelope) {
                //for some reason Login Success is fired even when login fails so the success must be checked....
                if (envelope.message.data.success) {
                    self.updateAllUserConsents();
                }
            });

            //after successful register always follows login -> unnecessary function in success message
            //Vendd.MessageBus.subscribe(Vendd.User.Messages.RegisterSuccess, self, self.updateAllUserConsents);

            //cookies widget
            if (self.cookiesWidgetWrapper.length > 0) {
                self.cookiesWidgetWrapper.on('click', '.js-accept', function (e) {
                    e.preventDefault();

                    var data = { fCookies: true, sCookies: true, mCookies: true, source: 'Cookies Widget' };
                    self.insertAllCookies(data);
                });
            }

            //cookies modal
            if (self.cookiesModalWrapper.length > 0) {
                self.cookiesModalWrapper.on('click', '.js-accept', function (e) {
                    e.preventDefault();

                    var data = { fCookies: true, sCookies: true, mCookies: true, source: 'Cookies Widget' };
                    self.insertAllCookies(data);
                    $.fancybox.close();
                });
            }

            if (self.cookiesModalWrapper.length > 0) {
                self.cookiesModalWrapper.on('click', '.js-decline', function (e) {
                    e.preventDefault();

                    var data = { fCookies: false, sCookies: false, mCookies: false, source: 'Cookies Widget' };
                    self.insertAllCookies(data);
                    $.fancybox.close();
                });
            }

            //cookies modal
            if (self.cookiesModalWrapper.length > 0) {
                self.cookiesModalWrapper.on('click', '.terms-link', function (e) {
                    e.preventDefault();

                    self.getCookiesWidgetModel();
                });
            }
        }

        //------------------------------------------------------------------------------
        this.initCookiesModal = function () {
            $(".open-cookies-modal").fancybox({
                modal: true
            });
            $(".open-cookies-modal").trigger("click");
        }

        //------------------------------------------------------------------------------
        this.activateCookies = function () {
            window.ScriptsActivator.loadAllScripts(
                self.cookiesStatus.functionalityCookies,
                self.cookiesStatus.marketingCookies,
                self.cookiesStatus.statisticCookies
            );
        };


        //------------------------------------------------------------------------------
        this.init = function () {
            //behave like consents are activated and we have consent of user for all cookies
            if (!LhApp.Context.IsConsentsEnabled) {

                self.cookieChecked = true;
                self.cookiesStatus.userHasSetCookies = true;
                self.cookiesStatus.functionalityCookies = true;
                self.cookiesStatus.marketingCookies = true;
                self.cookiesStatus.statisticCookies = true;

                self.activateCookies();

                return;//do not run anything else from consents manager
            }

            self.cookieChecked = document.cookie.indexOf(self.cookie) !== -1;
            self.getCookieStatus();
            self.activateCookies();
            self.registerEvents();

            if (!self.cookieChecked) {
                self.getCookieConsentsModel();
            } else if (!self.cookiesStatus.userHasSetCookies) {
                self.showCookiesWidget();
            }
        };

        self.init();

        return self;
    };
});
